export enum OttopilotCustomersWorkspaceCapabilityAccessOperation {
    create = "ecf7375d-7fa8-4c52-a2da-4da0b63870d7",
    read = "740efb03-527f-42e1-b59e-c41a21204124",
    update = "e285f2ee-9d09-4449-ac1f-97a099846415",
    delete = "0fe77921-c788-4c2e-9139-875433f3e0c6",
}
